import UnderConstruction from "../../errors/under-construction";

const TimesheetErrors = (): JSX.Element => {
  return <UnderConstruction />;
};
export default TimesheetErrors;
